import React from 'react';
const modules = [{
  id: 1,
  title: 'EL BLINDAJE INSTITUCIONAL',
  description: 'El respaldo legal e institucional que tu escuela necesita para actuar con seguridad y sin improvisación.',
  color: '#1B3A6B',
  features: ['Marco legal explicado en lenguaje claro', 'Qué es delito cuando el agresor tiene menos de 14 años', 'Protocolo de actuación paso a paso', 'Actas modelo listas para completar', 'Cuándo y cómo derivar al EOE', 'Notificación al supervisor escolar', 'Directorio de derivación institucional']
}, {
  id: 2,
  title: 'AULA ACTIVA',
  description: 'Actividades didácticas listas para trabajar bullying, emociones y convivencia con chicos de 6 a 12 años.',
  color: '#7C3AED',
  features: ['Actividades por ciclo: 1° a 3° y 4° a 6°', 'Dinámicas grupales sobre buen trato', 'Trabajo sobre emociones y empatía', 'Acuerdos de convivencia del aula', 'Actividades sobre tecnología y redes', 'Recursos imprimibles por actividad', 'Diploma de Buen Conviviente']
}, {
  id: 3,
  title: 'EL ADN DIGITAL',
  description: 'Todo para abordar violencia digital, grooming y riesgos de redes con chicos de primaria.',
  color: '#00BFA5',
  features: ['Grooming: qué es y cómo detectarlo', 'El rol del testigo digital en primaria', 'Huella digital y privacidad infantil', 'Taller de seguridad en videojuegos', 'Cómo actuar ante una difusión de imagen', 'Guía de configuración para familias', 'Contrato de uso de tecnología']
}, {
  id: 4,
  title: 'ALIANZA CON LAS FAMILIAS',
  description: 'El kit completo para liderar reuniones de padres efectivas y sin conflictos.',
  color: '#FF6B35',
  features: ['Agenda de reunión lista para usar', 'Guion para el docente: qué decir y qué no', 'Presentación visual para la reunión', 'Dinámicas participativas para padres', 'Folleto resumen para llevar a casa', 'Cómo responder a padres difíciles', 'Acuerdo de corresponsabilidad']
}];
export function Modules() {
  return <section className="bg-white py-6 md:py-12 lg:py-[60px]" data-id="element-105">
      <div className="container mx-auto px-4" data-id="element-106">
        <div className="text-center mb-5 md:mb-6 lg:mb-8" data-id="element-107">
          <h2 className="text-[#1B3A6B] font-poppins font-black text-3xl md:text-5xl mb-3" data-id="element-108">
            📚 4 MÓDULOS COMPLETOS
          </h2>
          <p className="text-[#555555] text-lg" data-id="element-109">
            Cada módulo incluye protocolos, actividades y materiales listos para
            usar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-5 lg:gap-6 max-w-6xl mx-auto" data-id="element-110">
          {modules.map(m => <div key={m.id} className="bg-white p-5 md:p-6 lg:p-8 rounded-[16px] shadow-[0_2px_20px_rgba(0,0,0,0.08)] border-l-[4px]" style={{
          borderLeftColor: m.color
        }} data-id="element-111">
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-112">
                <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{
              backgroundColor: m.color
            }} data-id="element-113">
                  MÓDULO {m.id}
                </span>
                <span className="px-3 py-1 rounded-full text-xs font-bold bg-[#FF6B35] text-white" data-id="element-114">
                  Contenido Exclusivo
                </span>
              </div>

              <h3 className="text-[#1B3A6B] font-poppins font-bold text-2xl mb-3" data-id="element-115">
                {m.title}
              </h3>
              <p className="text-[#2C2C2C] mb-4 md:mb-5 leading-relaxed" data-id="element-116">
                {m.description}
              </p>

              <ul className="space-y-2 md:space-y-2.5" data-id="element-117">
                {m.features.map((f, i) => <li key={i} className="flex items-start gap-3" data-id="element-118">
                    <span className="text-[#2D9B6F] font-bold" data-id="element-119">✅</span>
                    <span className="text-[#2C2C2C] text-sm" data-id="element-120">{f}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}